import { Scene, PerspectiveCamera, WebGLRenderer } from 'three'
import App from '../App'

export default class WebglScene {
  constructor(wrapper) {
    this.wrapper = wrapper
    this.createRenderer()
  }

  createRenderer() {
    this.scene = new Scene()
    this.renderer = new WebGLRenderer({
      premultipliedAlpha: false,
      depth: false,
      powerPreference: 'low-power'
    })

    this.renderer.setPixelRatio(1)
    this.renderer.setSize(window.innerWidth, window.innerHeight)

    this.initCamera()

    this.wrapper.appendChild(this.renderer.domElement)
  }

  initCamera() {
    const perspective = 500
    const fov = 180 * 2 * Math.atan(window.innerHeight / 2 / perspective) / Math.PI

    this.camera = new PerspectiveCamera(fov, window.innerWidth / window.innerHeight, 1, 1000)
    this.camera.position.set(0, 0, perspective)
  }

  render() {
    if (App.menu.menuOpen) return

    this.renderer.render(this.scene, this.camera)
  }

  resize() {
    this.camera.aspect = window.innerWidth / window.innerHeight
    this.camera.updateProjectionMatrix()

    this.renderer.setSize(window.innerWidth, window.innerHeight)
  }

  destroy() {
    this.renderer.dispose()
  }
}



// WEBPACK FOOTER //
// ./scripts/util/WebglScene.js